export const CssBaseline = ({ spacing, palette, shape, typography, shadows }) => {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        // MUI v4 -> MUI v5 - The body font size has changed from theme.typography.body2 (0.875rem) to theme.typography.body1 (1rem).
        // This is a fix to return to the previous values.
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          letterSpacing: '0.01071em',
        },
        '.introjs-helperLayer': {
          backgroundColor: 'rgb(255 255 255 / 20%)',
          border: '1px solid white',
          outline: '1px solid black',
        },
        '.introjs-tooltip': {
          minWidth: 250,
          maxWidth: 300,
        },
        '.introjs-tooltiptext': {
          ...typography.body1,
        },
        '.introjs-button:not(:first-child)': {
          marginLeft: spacing(1),
        },
        '.introjs-button': {
          backgroundImage: 'unset',
          border: 'unset',
          textShadow: 'unset',
          font: 'unset',
          padding: spacing(0.5, 1.2),
          ...typography.button,
          backgroundColor: palette.primary.main,
          color: palette.primary.contrastText,
          borderRadius: `${shape.borderRadius}px !important`,

          '&:active': {
            backgroundImage: 'unset',
            textDecoration: 'none',
            backgroundColor: palette.primary.dark,
            color: palette.primary.contrastText,
            boxShadow: shadows[25],
          },
          '&:hover': {
            backgroundImage: 'unset',
            textDecoration: 'none',
            backgroundColor: palette.primary.dark,
            color: palette.primary.contrastText,
          },
          '&:disabled': {
            backgroundColor: 'transparent',
          },
        },
      },
    }
  };
};
